import * as _ from 'lodash';
import { ReimbursementType, WageAndTravelDrawerViewType, WageAndTravelStatus, WageAndTravelType, WageAndTravelViewType } from '@nkr/enums/index';
import { IWatrReimbursement, IWatrRequest, IWatrRequestTravels } from '@nkr/models/index';

export const getViewTypeByStatus = (requestStatus: number) => {
    switch (requestStatus) {
        case WageAndTravelStatus.PendingDocuments:
        case WageAndTravelStatus.PendingNkrVerifyTax:
        case WageAndTravelStatus.PendingNkrVerifyStub:
        case WageAndTravelStatus.PendingNkrVerifyAmount:
            return WageAndTravelViewType.VerifyWage;

        default:
            return WageAndTravelViewType.RequestData;
    }
}

export const getUpdatedList = (list: IWatrRequest[], newRequest: IWatrRequest) => {
    let updatedList = _.cloneDeep(list).map(item => {

        if (item.id == newRequest.id) {
            newRequest.logs = item.logs;
            newRequest.roundTripInstances = item.roundTripInstances;
            
            if (item.paystubs && item.paystubs.length > 0 && (!newRequest.paystubs || newRequest.paystubs.length === 0)) {
                newRequest.paystubs = item.paystubs;
            }
            
            if (item.requestWeeks && item.requestWeeks.length > 0 && (!newRequest.requestWeeks || newRequest.requestWeeks.length === 0)) {
                newRequest.requestWeeks = item.requestWeeks;
            }

            item = newRequest
        }

        return item;
    });

    return updatedList;
}

export const getUpdatedListForTravels = (list: IWatrRequest[], newRequest: IWatrRequestTravels) => {
    var updatedList = _.cloneDeep(list);
    var notTheRecord = updatedList.filter(x => x.id == newRequest.requestId);
    var record = updatedList.find(x => x.id == newRequest.requestId);

    var requestTravels = record.requestTravels;
    var notTravelRequests = requestTravels.filter(x => x.id != newRequest.id);
    var travelRequest = requestTravels.find(x => x.id == newRequest.id);

    travelRequest = newRequest

    var newList = [...notTheRecord, { ...record, requestTravels: [...notTravelRequests, travelRequest] }]

    return newList;
}

export const getTotalWagesReimbursedDays = (request: IWatrRequest, reimbursements: IWatrReimbursement[]) => {
    let totalWagesReimbursed = 0;

    reimbursements.forEach(item => {
        if (item.reimbursementType == ReimbursementType.Wages
            || item.reimbursementType == ReimbursementType.CreditReturnLostWageReimbursement)
            totalWagesReimbursed += item.amount;
    });

    let daily = request.wageReimbursementAmount > 0 ? request.wageReimbursementAmount : request.estimatedWageReimbursementAmount;

    let totalWagesReimbursedDays = totalWagesReimbursed > 0 && daily > 0
        ? Math.ceil(totalWagesReimbursed / daily)
        : 0;

    return totalWagesReimbursedDays;
}

const drawerTitleMap = [
    { type: WageAndTravelViewType.RequestData, title: 'Wage & Expenses Request' },
    { type: WageAndTravelViewType.ConfirmDonation, title: 'Confirm Donation' },

    { type: WageAndTravelViewType.VerifyAmount, title: 'Verify Amount' },
    { type: WageAndTravelViewType.VerifyStub, title: 'Verify Income' },
    { type: WageAndTravelViewType.VerifyTravel, title: 'Verify Travel Expenses' },
    { type: WageAndTravelViewType.VerifyWage, title: 'Verify Wages' },

    { type: WageAndTravelViewType.ReimburseWageAudit, title: 'Wage & Expenses Request' },
    { type: WageAndTravelViewType.ReimburseWage, title: 'Record Wage Payments' },

    { type: WageAndTravelViewType.ReimburseTravel, title: 'Record Expense Payments' },
    { type: WageAndTravelViewType.RequestAdditionalDays, title: 'Request Additional Days of Wage Reimbursement' },
];

export const getDrawerTitle = (type: WageAndTravelViewType) => {
    let f = drawerTitleMap.find(x => x.type == type);

    return f != null ? f.title : '';
}